import { useLayoutEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";

import Button from "../custom/button";
import Loading from "consumer/setup/loading";
import mainStyle from "./main.module.css";

import { get_notice_list } from "consumer/@@@/get_notice_list";
import { get_link } from "consumer/@@@/get_link";

export default function Main() {
	const navigate = useNavigate();

	const [searchParams, Set_searchParams] = useSearchParams();

	const isMounted = useRef(0);

	const [noticeList, Set_noticeList] = useState([]);

	const [loading, Set_loading] = useState(true);

	const notice = useRef();

	useLayoutEffect(() => {
		if (isMounted.current === 0) {
			// 학원 직접 링크로 오는지 체크
			async function a() {
				let check = true;
				let branch_id = "";

				const link = searchParams.get("link");
				if (link !== null) {
					const link_data = await get_link({
						link: link,
					});
					check = link_data["check"];
					branch_id = link_data["branch_id"];
				}

				if (check === false) {
					navigate("/step2", {
						state: {
							branch_id: branch_id,
						},
						replace: true,
					});
				} else if (check === true) {
					// 메인과 학원 공지가 같은 로직이므로 0000 코드로 메인 공지를 불러옴
					get_notice_list({
						branch_id: "0000",
						Set_noticeList: Set_noticeList,
						isMounted: isMounted,
					});
				}
			}
			a();
		}
	}, []);

	useLayoutEffect(() => {
		if (isMounted.current === 1) {
			// 공지가 한 개 이상일 때만 첫번째 공지 넣기
			// 여러 개 보여줄지 고민
			if (noticeList.length > 0) {
				notice.current.innerHTML = noticeList[0]["content"];
			}

			Set_loading(false);
		}
	}, [noticeList]);

	return (
		<>
			<Loading loading={loading}></Loading>

			<div id="main" className={mainStyle.main}>
				<div className={mainStyle.noticeWrap}>
					<div ref={notice}></div>
				</div>

				<div className={mainStyle.buttonWrap}>
					<Button
						text="신청"
						style={{
							width: "30%",
						}}
						event={{
							onClick: () => navigate("/step1"),
						}}
					></Button>

					<Button
						text="신청 조회"
						style={{
							width: "30%",
						}}
						event={{
							onClick: () => navigate("/inquiry"),
						}}
					></Button>
				</div>
			</div>
		</>
	);
}
